import { RcIconButton } from '@/components/molecules/interactive/RcIconButton'
import { UserAvatar } from '@/components/organisms/avatar/UserAvatar'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import Stack from '@mui/material/Stack'
import { ChatMember } from '@rallycry/social-api-typescript'

export const ChatMembersList = ({
  members,
  isModerator,
  removeParticipant
}: {
  members: ChatMember[]
  isModerator: boolean
  removeParticipant: (externalId: string, id: string) => void
}) => (
  <List disablePadding>
    {members
      .filter(it => !!it.accessLevel)
      .map(m => (
        <ListItemButton
          key={m.id}
          sx={{
            '&:hover .remove-icon': {
              visibility: 'visible'
            }
          }}
        >
          <ListItem disableGutters disablePadding>
            <Stack
              direction='row'
              alignItems='center'
              justifyContent='space-between'
              width='100%'
            >
              <UserAvatar
                key={m.id}
                user={{ ...m, id: Number(m.id) }}
                disableClick={!Number(m.id)}
                size='small'
                sx={{ flexGrow: 1 }}
              />
              {isModerator ? (
                <RcIconButton
                  className='remove-icon'
                  color='error'
                  size='extraSmall'
                  icon={['fal', 'user-minus']}
                  onClick={() => {
                    removeParticipant(m.externalId!, m.id!)
                  }}
                  sx={{ marginY: 3, visibility: 'hidden' }}
                  disabled={!Number(m.id)}
                />
              ) : null}
            </Stack>
          </ListItem>
        </ListItemButton>
      ))}
  </List>
)
